import React from 'react';
import styles from './ContactOptionsMenu.module.scss';
import {
  DropdownExpandFromOrigin,
  DropdownMenu,
  DropdownTriggerVariant,
} from '@repo/components/menus';
import { ID } from '@repo/utils/types';
import { useContactPersonOptions } from '@repo/hooks';

export function ContactOptionsMenu({
  contactID,
  onOpen,
  onClose,
  app,
}: {
  contactID: ID;
  onOpen?: () => void;
  onClose?: () => void;
  app?: 'web' | 'browser-extension';
}) {
  const [options, handleOpen] = useContactPersonOptions(contactID, { onOpen });

  let triggerVariant: DropdownTriggerVariant = 'contactOptions';
  let expandFrom: DropdownExpandFromOrigin = 'top-center';

  if (app === 'browser-extension') {
    triggerVariant = 'browserExtensionContactOptions';
    expandFrom = 'top-left';
  }

  return (
    <DropdownMenu
      options={options}
      menuClassName={styles.contactOptionsMenu}
      triggerClassName={styles.contactOptionsMenuTrigger}
      onOpen={handleOpen}
      onClose={onClose}
      expandFrom={expandFrom}
      triggerVariant={triggerVariant}
    />
  );
}
